import { Component, Input } from '@angular/core';
import { LandingPageSection } from 'src/app/landing-page.model';

@Component({
  selector: 'app-page-spacer',
  templateUrl: './page-spacer.component.html',
  styleUrls: ['./page-spacer.component.scss']
})
export class PageSpacerComponent {

  @Input() data: LandingPageSection;
  @Input() desktopWidth: string = "1110";


  constructor() { }

}
